module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_dress-29a541a64a3b0b2df80be33c88610e9e.jpg";